import { DEFAULT_QUALITY_SCORECARD_WINDOW_DAYS } from './brokerQualityScorecardLoansApi.constants';
import { BROKER_QUALITY_SCORECARD_UNDERWRITING_URL } from './brokerQualityScorecardUnderwritingApi.constants';

/**
 * File-quality scorecard client — Underwriting-gateway half (DEV-3777). GET
 * /api/brokerQualityScorecard?windowDays=90 fills conditionsClearedWithinSlaPct
 * and conditionClearTurnTimeMedianHours; the other three keys come back
 * null-flagged (this service does not own them) and are merged with the Loans
 * half.
 *
 * Same dark-until-flag contract as the Loans half: the endpoint 404s when the
 * backend toggle is off, so the caller passes skipResponseInterceptor
 * forbiddenError and treats any error/404 as "not available" → zone hidden.
 *
 * Response shape is identical to the Loans half (same five metric keys).
 */
export class BrokerQualityScorecardUnderwritingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getQualityScorecard({
    windowDays = DEFAULT_QUALITY_SCORECARD_WINDOW_DAYS,
    config = {},
  } = {}) {
    return this.#http.get(BROKER_QUALITY_SCORECARD_UNDERWRITING_URL, {
      ...config,
      params: { windowDays },
    });
  }
}
